var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"d-none d-md-block header",attrs:{"color":"primary","elevation":"0","height":"110px"}},[_c('HeaderBase',{staticClass:"p-0"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }